import {createStore} from 'vuex'; // https://vuex.vuejs.org/guide/
import Cookies from 'js-cookie';

import globalGetters from './globalGetters';
import globalActions from './globalActions';
import globalMutations from './globalMutations';

export default createStore({
  // strict только в dev: в strict-режиме Vuex делает deep-watch всего состояния на каждую
  // мутацию — это заметно дороже, а сканер мутирует состояние очень часто.
  strict: import.meta.env.DEV,
  state: {
    settings: null,
    scannerPageType: null, // live, prematch
    scannerPageName: null, // arbs, valuebets
    userData: null,
    userBookmakers: null,
    directories: null,
    currencies: null,
    interfaceZoom: null,
    sidebarHeight: '100%',
    countriesList: null,
    leaguesList: null,
    headerSearchQuery: '',
    globalLoadError: false,
    globalLoadWarning: {isWarning: false, warningText: null, warningLink: null, warningLinkTitle: null},
    arbsFormulas: null,
    defaultFilterRequestParams: null,
    scanningIssueBookmakers: null, // {live: [<bookmaker ids>], prematch: [...]} — /main/scanning_issues/bookmakers
    prevKoefFormat: null,
    showHints: true,
    percentValue: null,
    darkMode: Cookies.get('darkmode') === 'true',
  },
  mutations: {
    ...globalMutations,
  },
  actions: {
    ...globalActions,
  },
  getters: {
    ...globalGetters,
  },
});
